import EntityType from '@enums/EntityType';

export default function isTag(entityType) {
  if (
    entityType === EntityType.ACTIVITY_TAG ||
    entityType === EntityType.ACTIVITY_TAG_CATEGORY ||
    entityType === EntityType.ROLE_TAG ||
    entityType === EntityType.ROLE_TAG_CATEGORY ||
    entityType === EntityType.GROUP_TAG ||
    entityType === EntityType.GROUP_TAG_CATEGORY
  ) {
    return true;
  }
}
